import styled from "styled-components";
import {Breakpoint} from "@mui/material";

export const Aside = styled.aside<{breakpoint?: Breakpoint}>`
	display: none;
	background-color: #dddddd;
	overflow: hidden;
	margin: 20px 37px;
	height: 90px;

	${({theme, breakpoint}) => theme.breakpoints.up(breakpoint || "mobile")} {
		margin: 0;
		min-width: 300px;
		height: 250px;
	}
`;
